import { UserAvatar } from "components/Atoms/Avatar";
import { ToggleableBellPhosphorIconButton, ToggleableEmailPhosphorIconButton } from "components/Atoms/ToggleablePhosphorIconButton";
import { RelativeTimeToNowDotLabel } from "components/Dot/DotLabel";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import OwnersFilter from "components/filters/Filters/OwnersFilter";
import { TaskManagerSortFilter } from "components/filters/Filters/SortFilter";
import TaskManagerPeriodFilter from "components/filters/Filters/TaskManagerPeriodFilter";
import ListTemplate from "components/ListTemplate";
import SmallDetails from "components/SmallDetails/SmallDetails";
import moment from "moment";
import React from "react";
import { formatShortDateWithTimeZone } from "utilities";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useLoaderData } from "react-router";

const TaskManagerListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.TaskManagerListFrontModel>();

  return <ListTemplate
    title={viewModel.pageTitle}
    filterSet="taskManager_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.TaskManager.Paginated}
    getId={item => item.userTaskId}
    onDelete={item => window.CoreApi.UserTask.DeleteUserTask(item.userTaskId)}
    layout={{
      type: "table",
      columns: [{
        key: "deadline",
        header: RESX.Message.Deadline,
        render: item => {
          const deadlineMoment = moment.utc(item.deadlineSource).add(item.deadlineOffsetInDays, "days");
          return <div>
            <div>{formatShortDateWithTimeZone(deadlineMoment)}</div>
            <RelativeTimeToNowDotLabel dateTime={deadlineMoment} />
          </div>
        }
      }, {
        key: "relatedTo",
        header: RESX.Message.RelatedTo,
        render: item => <SmallDetails
          label={item.title}
          subLabel={`${site.currentEnvironment[item.parent.objectType].singular}: ${item.parent.description}`}
          link={item.parent.detailUrl}
        />
      }, {
        key: "assignedTo",
        header: RESX.Message.AssignedTo,
        render: item => <UserAvatar user={item.assignedTo} />,
      }, {
        key: "toggleNotificationReminder",
        header: "",
        size: "30px",
        render: item => <ToggleableBellPhosphorIconButton
          layout="in-square"
          initialValue={item.reminderPopup}
          update={value => window.CoreApi.UserTask.SetTaskReminderPopup({
            userTaskId: item.userTaskId,
            state: value
          })}
        />
      }, {
        key: "toggleEmailReminder",
        header: "",
        size: "30px",
        render: item => <ToggleableEmailPhosphorIconButton
          layout="in-square"
          initialValue={item.reminderEmail}
          update={value => window.CoreApi.UserTask.SetTaskReminderEmail({
            userTaskId: item.userTaskId,
            state: value
          })}
        />
      }]
    }}
    filters={<>
      <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
      <OwnersFilter title={RESX.SelectionManager.AssignedTo} />
      <TaskManagerPeriodFilter />
      <TaskManagerSortFilter />
    </>}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction,
    }}
  />
};

export default TaskManagerListApp;